import { fetchCommunicationPreferences } from "@/domain/communication-preferences/api"
import { atom } from "jotai"
import { atomWithRefresh, unwrap } from "jotai/utils"
import profileAtom from "./profile"

const customerIdAtom = atom((get) => get(profileAtom)?.id ?? null)

/** The logged customer's saved order-update choice, tagged with the customer; re-read on login or on `set(communicationPreferencesAtom)`. */
export const communicationPreferencesAtom = atomWithRefresh(async (get) => {
  const customerId = get(customerIdAtom)
  return { customerId, preferences: customerId ? await fetchCommunicationPreferences() : null }
})

const lastPreferencesAtom = unwrap(communicationPreferencesAtom, (previous) => previous)

/** Non-suspending view of {@link communicationPreferencesAtom}: `undefined` while the current customer's read is in flight, `null` without a customer or when the read failed. */
export const communicationPreferencesViewAtom = atom((get) => {
  const customerId = get(customerIdAtom)
  const loaded = get(lastPreferencesAtom)
  if (!customerId) return null
  return loaded && loaded.customerId === customerId ? loaded.preferences : undefined
})
